import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { WalletApi } from "@/api_fsb";
import type { CashoutRequestSummary } from "@/api_fsb";

const walletApi = new WalletApi();

// /<product-id>/cashout/

export const cashoutRequests = createApi({
  reducerPath: "cashoutRequests",
  baseQuery: fakeBaseQuery<string>(),
  endpoints: (builder) => ({
    getUserCashouts: builder.query<
      CashoutRequestSummary[],
      { bpid: string; productUserId: string }
    >({
      queryFn: async ({ bpid, productUserId }) => {
        try {
          const res = await walletApi.filterUserCashoutsProductIdCashoutGet(
            bpid,
            productUserId,
          );
          return { data: res.data.cashouts as CashoutRequestSummary[] };
        } catch (e) {
          return { error: e instanceof Error ? e.message : "Request failed" };
        }
      },
    }),
  }),
});

export const { useGetUserCashoutsQuery } = cashoutRequests;
